module.exports = __webpack_public_path__ + "img/cert-change.7aac03ee.svg";